import customHandlers from '../helpers/custom-handlers';
import { OPTIONS_SYMBOL } from '../constants/symbols';
import unsubscribe from './unsubscribe';

// this function only for internal sdk usage
const callHookListeners = (hookName, ...args) => {
  if (customHandlers.has(hookName)) {
    customHandlers.get(hookName).forEach((callback) => {
      if (callback[OPTIONS_SYMBOL] && callback[OPTIONS_SYMBOL].once) {
        unsubscribe(hookName, callback);
      }

      callback(...args);
    });
  }
};

export default callHookListeners;
